/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

/**
 * Provides a utility for determining if the application is current being executed
 * in development mode.
 *
 * ```typescript
 *
 *    import {isDevMode} from '@ion/applications/src/utils/env';
 *    const isDev = isDevMode();
 *
 * ```
 */
export const isDevMode = (): boolean => {
  return !!process?.env?.NEXT_PUBLIC_IS_DEV || false;
};
